<template>
  <div class="customerData">
    <div class="customerData-title">
      <span> 客户版本</span>
      <span class="customerData-showCollect" @click="toShowCollect">
        <i class="icon iconfont icon-icon_lable"></i>
        已有人群
      </span>
    </div>
    <div
      class="customerData-tag_empty"
      v-if="customerDataConditionGroupCollectionVoList.length === 0"
    >
      <span>筛选标签</span>
      <span @click="toAddNew">+ 筛选条件</span>
    </div>
    <div class="customerData-tag" v-else>
      <div class="customerData-tagContent">
        <div class="customerData-tagGroup">
          <div
            class="customerData-tagGroupItem"
            v-for="(
              collectionVo, index
            ) in customerDataConditionGroupCollectionVoList"
            :key="index"
          >
            <span class="customerData-tagGroupItemName"
              >筛选{{ index + 1
              }}{{
                collectionVo.labelLogic === 1 ? "(组内交集)" : "(组内并集)"
              }}</span
            >
            <div
              class="customerData-tagGroupItemList"
              v-for="(
                conditionGroup, i
              ) in collectionVo.customerDataConditionGroupVoList"
              :key="i"
            >
              {{
                conditionGroup.customertaggroupName +
                ":" +
                conditionGroup.customerTagDTOList.join(",")
              }}
              <span
                class="icon iconfont icon-icon_close"
                @click="deleteConditionGroup(index, i)"
              ></span>
            </div>
          </div>
        </div>
        <span></span>
      </div>
      <div class="customerData-tagHandle">
        <span class="customerData-tagHandle_item" @click="toAddNew"
          >+ 继续筛选</span
        >
        <span class="customerData-tagHandle_line"></span>
        <el-popover
          placement="bottom"
          width="270"
          v-model:visible="visibleCollect"
          ref="collect"
        >
          <div class="customerData-collectContent">
            <span>收藏名称</span>
            <el-input v-model="collectName"></el-input>
          </div>
          <div class="customerData-collectFooter">
            <span @click="visibleCollect = false">取消</span>
            <span @click="toCollect">保存</span>
          </div>
          <template v-slot:reference>
            <span
              @click="
                visibleCollect = true;
                collectName = '';
              "
              >存为人群</span
            >
          </template>
        </el-popover>
      </div>
    </div>
    <div class="customerData-content">
      <div class="customerData-contentHeader">
        <span
          >共{{ masterAccountCount }}个总部账号， 共
          {{ customerCount }} 个客户， {{ brandNamesCount }} 个品牌</span
        >
      </div>
      <el-table
        :data="tableData"
        style="width: 100%"
        v-loading="loading"
        :tree-props="{ children: 'children' }"
        row-key="customerUid"
        class="customerData-table"
        empty-text="无数据,请先添加筛选条件哦~"
      >
        <el-table-column prop="clientId" label="客户ID"> </el-table-column>
        <el-table-column prop="" label="账号">
          <template v-slot="scope">
            <span>{{
              scope.row.isChildren ? "" : scope.row.account || "-"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="" label="行业">
          <template v-slot="scope">
            {{ scope.row.isChildren ? "" : scope.row.industry || "-" }}
          </template>
        </el-table-column>
        <el-table-column prop="" label="品牌名称">
          <template v-slot="scope">
            {{ scope.row.isChildren ? "" : scope.row.brandNames || "-" }}
          </template>
        </el-table-column>
        <el-table-column label="服务名称" width="115">
          <template v-slot="scope">
            <span>
              {{ scope.row.serviceName || "-" }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop=""
          label="客户端版本"
          :show-overflow-tooltip="true"
          width="320"
        >
          <template v-slot="scope">
            {{ scope.row.isChildren ? "" : scope.row.clientVersion || "-" }}
          </template>
        </el-table-column>
        <el-table-column prop="" label="手机号" width="100">
          <template v-slot="scope">
            {{ scope.row.isChildren ? "" : scope.row.tel || "-" }}
          </template>
        </el-table-column>
        <el-table-column prop="" label="归属人">
          <template v-slot="scope">
            {{ scope.row.isChildren ? "" : scope.row.belonger || "-" }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100">
          <template v-slot="scope">
            <el-button
              v-if="!scope.row.isChildren"
              @click="_getCustomerTagGroupDtoList(scope.row.customerUid)"
              type="text"
              size="small"
              >查看标签</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        layout="total,->, prev, pager, next,jumper"
        :total="total"
        background
      >
      </el-pagination>
    </div>
    <el-drawer
      title="查看标签"
      v-model="showTagList"
      direction="rtl"
      size="600px"
      custom-class="customerData-showTag"
    >
      <div class="customerData-showTagList customerPortrait">
        <section v-for="(userTag, index) in userTagsByGroup" :key="index">
          <div class="customerPortrait-heaader">
            <span>{{ index + 1 }}</span>
            <span>{{ userTag.customertaggroupName }}</span>
          </div>
          <div class="customerPortrait-content">
            <span
              :class="{ 'customerPortrait-content_choosed': userTag.isChoose }"
              >{{ userTag.customertagName }}</span
            >
          </div>
        </section>
      </div>
    </el-drawer>
    <el-drawer
      v-model="showCollect"
      direction="rtl"
      size="600px"
      custom-class="customerData-showEdit"
    >
      <template v-slot:title>
        <div class="customerData-showEditTitle">
          <span>已有人群</span>
        </div>
      </template>
      <div class="customerData-showCollectContent">
        <div
          class="customerData-showCollectItem"
          :class="{
            'customerData-showCollectItem_choose':
              index === chooseConditionIndex,
          }"
          @click="chooseCondition(index)"
          v-for="(condition, index) in conditionDto"
          :key="index"
        >
          <section class="customerData-showCollectItemHeader">
            <span>{{ condition.customerDataConditionName }}</span>
            <el-popconfirm
              title="确认删除该人群"
              @confirm="deleteCondition(condition.customerDataConditionUid)"
            >
              <template #reference>
                <span>
                  <i class="icon iconfont icon-icon_trash"></i>
                </span>
              </template>
            </el-popconfirm>
          </section>
          <section class="customerData-showCollectItemList">
            <div
              v-for="(
                conditionGroup, i
              ) in condition.customerDataConditionGroupCollectionDtoList"
              :key="i"
              v-html="
                getConditionGroupName(
                  conditionGroup.customerDataConditionGroupDtoList,
                  conditionGroup.labelLogic
                )
              "
            ></div>
          </section>
        </div>
      </div>
    </el-drawer>
    <el-drawer
      v-model="showEdit"
      direction="rtl"
      size="600px"
      custom-class="customerData-showEdit"
    >
      <template v-slot:title>
        <div class="customerData-showEditTitle">
          <span>筛选条件</span>
        </div>
      </template>
      <div class="customerData-showEditContent">
        <section class="customerData-selectConditions">
          <div class="customerData-selectConditionRelation">
            <div>
              <span
                >关系：
                <el-radio-group v-model="labelLogic">
                  <el-radio :label="1">交集</el-radio>
                  <el-radio :label="0">并集</el-radio>
                </el-radio-group>
              </span>
            </div>
            <span>将生效于以下所有条件</span>
          </div>
        </section>
        <section class="customerData-selectList">
          <div
            class="customerData-selectConditionsItem"
            v-for="(selectTag, index) in selectTags"
            :key="index"
          >
            <div class="customerData-selectConditionsItemTitle">
              <span>条件{{ index + 1 }}</span>
              <el-select
                v-model="selectTag.customerTagGroupUid"
                filterable
                remote
                reserve-keyword
                placeholder="标签组、标签说明"
                :remote-method="remoteMethod"
                @change="setSelectTag(index)"
              >
                <el-option
                  v-for="item in customertaggroups"
                  :key="item.customertaggroupUid"
                  :label="item.customertaggroupName"
                  :value="item.customertaggroupUid"
                >
                </el-option>
              </el-select>
            </div>
            <el-checkbox-group
              v-model="selectTag.customerTagUidList"
              @change="changeCustomerTagUidList2(index)"
              v-if="
                selectTag.customerTagDTOList &&
                selectTag.customerTagDTOList.length > 0
              "
            >
              <el-checkbox
                :label="tag.customertagUid"
                @click="
                  changeCustomerTagUidList($event, tag.customertagUid, index)
                "
                v-for="(tag, tagIndex) in selectTag.customerTagDTOList"
                :key="tagIndex"
                >{{ tag.customertagName }}</el-checkbox
              >
            </el-checkbox-group>
          </div>
        </section>
        <section class="customerData-selectHandle" @click="toPushNewTag">
          + 添加条件
        </section>
      </div>
      <div class="customerData-showEditFooter">
        <span @click="toPushCustomerDataConditionList">确定</span>
        <span @click="showEdit = false">取消</span>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { ElMessage } from 'element-plus'
import { getCustomerTagGroupDtoByName, deleteCustomerDataCondition, getCustomerDataConditionDto, getCustomerTagGroupDtoList, getCustomerDataPageDto, addCustomerDataPageCondition } from '../../API/customVersion'
export default {
  data () {
    return {
      chooseConditionIndex: -1,
      showCollect: false,
      visibleCollect: false,
      loading: false,
      customerDataConditionGroupCollectionVoList: [],
      customertaggroups: [],
      showEdit: false,
      showEditTitle: 1,
      conditionDto: [],
      collectName: '',
      showTagList: false,
      currentPage: 1,
      brandNamesCount: 0,
      customerCount: 0,
      masterAccountCount: 0,
      userTagsByGroup: [],
      pageSize: 20,
      isChooseAll: false,
      isAll: false,
      total: 0,
      tableData: [],
      labelLogic: 1,
      selectTags: [],
      collectNames: []
    }
  },
  mounted () {
    this.getCollectNames()
  },
  methods: {
    deleteConditionGroup (collectionVoIndex, conditionGroupVoIndex) {
      const collectionVo = this.customerDataConditionGroupCollectionVoList[collectionVoIndex]
      collectionVo.customerDataConditionGroupVoList.splice(conditionGroupVoIndex, 1)
      if (collectionVo.customerDataConditionGroupVoList.length === 0) {
        this.customerDataConditionGroupCollectionVoList.splice(collectionVoIndex, 1)
      } else {
        this.customerDataConditionGroupCollectionVoList.splice(collectionVoIndex, 1, collectionVo)
      }
      this._getCustomerDataPageDto()
    },
    async toShowCollect () {
      this.conditionDto = await getCustomerDataConditionDto()
      this.showCollect = true
    },
    changeCustomerTagUidList2 (index) {
      if (this.isChooseAll && this.isAll) {
        const uids = [...this.selectTags[index].customerTagDTOList.map(item => item.customertagUid)]
        const obj = Object.assign({}, this.selectTags[index])
        obj.customerTagUidList.splice(0, obj.customerTagUidList.length, ...uids)
        this.selectTags.splice(index, 1, obj)
      } else if (!this.isChooseAll && this.isAll) {
        const obj = Object.assign({}, this.selectTags[index])
        obj.customerTagUidList.splice(0, obj.customerTagUidList.length)
        this.selectTags.splice(index, 1, obj)
      }
    },
    changeCustomerTagUidList (e, val, index) {
      if (e.target.tagName === 'INPUT') return
      this.isAll = false
      if (val === '-1' && this.selectTags[index].customerTagUidList.indexOf('-1') !== -1) {
        this.isAll = true
        this.isChooseAll = false
      } else if (val === '-1' && this.selectTags[index].customerTagUidList.indexOf('-1') === -1) {
        this.isChooseAll = true
        this.isAll = true
      }
    },
    toPushCustomerDataConditionList () {
      const filterArr = this.selectTags.filter(item => item.customerTagGroupUid && item.customerTagUidList.length > 0).map(
        item => {
          const customerTagUidList = item.customerTagUidList.filter(item => item !== '-1')
          return {
            customertaggroupName: item.customertaggroupName,
            customerTagGroupUid: item.customerTagGroupUid,
            customerDataTagUidList: customerTagUidList,
            customerTagDTOList: item.customerTagDTOList.filter(i => customerTagUidList.findIndex(c => c === i.customertagUid) !== -1).map(item => item.customertagName)
          }
        }
      )
      if (filterArr.length > 0) {
        this.customerDataConditionGroupCollectionVoList.push({
          customerDataConditionGroupVoList: filterArr,
          labelLogic: this.labelLogic
        })
        this._getCustomerDataPageDto()
      }

      this.showEdit = false
    },
    chooseCondition (index) {
      this.chooseConditionIndex = index
      const customerDataConditionGroupCollectionVoList = this.conditionDto[index].customerDataConditionGroupCollectionDtoList.map(
        item => {
          const customerDataConditionGroupVoList = item.customerDataConditionGroupDtoList.map(i => {
            return {
              customerDataTagUidList: i.customerDataTagDtoList.map(customerDataTagDto => customerDataTagDto.customerTagUid),
              customerTagGroupUid: i.customerTagGroupUid,
              customertaggroupName: i.customerTagGroupName,
              customerTagDTOList: i.customerDataTagDtoList.map(customerDataTagDto => customerDataTagDto.customerTagName)
            }
          })
          return {
            customerDataConditionGroupVoList,
            labelLogic: item.labelLogic
          }
        }
      )
      this.customerDataConditionGroupCollectionVoList = customerDataConditionGroupCollectionVoList
      this._getCustomerDataPageDto()
    },
    async deleteCondition (customerDataConditionUid) {
      await deleteCustomerDataCondition({ customerDataConditionUid })
      ElMessage({
        message: '删除成功',
        type: 'success'
      })
      this.conditionDto = await getCustomerDataConditionDto()
    },
    async getCollectNames () {
      const conditionDto = await getCustomerDataConditionDto()
      this.collectNames = conditionDto.map(item => item.customerDataConditionName)
    },
    getConditionGroupName (list, labelLogic) {
      const label = labelLogic === 1 ? '<span style="font-weight:600;margin:0 6px;">且</span>' : '<span style="font-weight:600;margin:0 6px;">或</span>'
      let resultStr = ''
      list.forEach((item, index) => {
        resultStr += (item.customerTagGroupName + ':' + item.customerDataTagDtoList.map(customerDataTag => customerDataTag.customerTagName).join(','))
        if (index !== list.length - 1) {
          resultStr += label
        }
      })
      return resultStr
    },
    async _getCustomerTagGroupDtoList (customerUid) {
      const userTagsByGroup = await getCustomerTagGroupDtoList({ customerUid })
      userTagsByGroup.map(item => {
        if (this.customerDataConditionGroupCollectionVoList.findIndex(customerData => {
          return customerData.customerDataConditionGroupVoList.findIndex(vo => {
            return vo.customerDataTagUidList.findIndex(uid => uid === item.customertagUid) !== -1
          }
          ) !== -1
        }) !== -1) {
          item.isChoose = true
        }
      })
      this.userTagsByGroup = userTagsByGroup
      this.showTagList = true
    },
    async toCollect () {
      if (this.collectName === '') {
        ElMessage({
          message: '请先填写收藏名称再保存',
          type: 'warning'
        })
      } else if (this.collectNames.findIndex(item => item === this.collectName) !== -1) {
        ElMessage({
          message: '收藏名称不允许重复',
          type: 'warning'
        })
      } else {
        const res = await addCustomerDataPageCondition({
          customerDataConditionGroupCollectionVoList: this.customerDataConditionGroupCollectionVoList,
          name: this.collectName
        })
        if (res.status === 'success') {
          ElMessage({
            message: '收藏成功',
            type: 'success'
          })

          this.getCollectNames()
        } else {
          ElMessage.error(res.messages)
        }
        this.visibleCollect = false
      }
    },
    async _getCustomerDataPageDto () {
      if (this.customerDataConditionGroupCollectionVoList.length === 0) {
        return
      }
      this.loading = true
      const res = await getCustomerDataPageDto({
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        customerDataConditionGroupCollectionVoList: this.customerDataConditionGroupCollectionVoList
      })
      const tableData = []
      res.customerDataPageDtoList.forEach((item, index) => {
        const obj = Object.assign({}, item)
        if (item.customerDataServiceInfoDtoList && item.customerDataServiceInfoDtoList.length > 1) {
          obj.children = item.customerDataServiceInfoDtoList.map(i => {
            return {
              customerUid: i.customerUid + 'children',
              endDatetime: i.endDatetime,
              isRenewed: i.isRenewed,
              renewDatetime: i.renewDatetime,
              serviceName: i.serviceName,
              startDatetime: i.startDatetime,
              isChildren: true
            }
          })
          obj.endDatetime = item.customerDataServiceInfoDtoList[0].endDatetime
          obj.renewDatetime = item.customerDataServiceInfoDtoList[0].renewDatetime
          obj.serviceName = `共${item.customerDataServiceInfoDtoList.length}个服务`
          obj.startDatetime = item.customerDataServiceInfoDtoList[0].startDatetime
          obj.isRenewed = item.customerDataServiceInfoDtoList[0].isRenewed
        } else if (item.customerDataServiceInfoDtoList && item.customerDataServiceInfoDtoList[0]) {
          obj.endDatetime = item.customerDataServiceInfoDtoList[0].endDatetime
          obj.renewDatetime = item.customerDataServiceInfoDtoList[0].renewDatetime
          obj.serviceName = item.customerDataServiceInfoDtoList[0].serviceName
          obj.startDatetime = item.customerDataServiceInfoDtoList[0].startDatetime
          obj.isRenewed = item.customerDataServiceInfoDtoList[0].isRenewed
        }
        tableData.push(obj)
      })
      this.tableData = tableData
      this.total = res.total || 0
      this.brandNamesCount = res.brandNamesCount || 0
      this.customerCount = res.customerCount || 0
      this.masterAccountCount = res.masterAccountCount || 0
      this.loading = false
    },
    handleCurrentChange (currentPage) {
      this.currentPage = currentPage
      this._getCustomerDataPageDto()
    },
    handleSizeChange (pageSize) {
      this.pageSize = pageSize
      this._getCustomerDataPageDto()
    },

    async remoteMethod (content) {
      this.customertaggroups = await getCustomerTagGroupDtoByName({ content })
    },
    toPushNewTag () {
      this.selectTags.push({
        customerTagGroupUid: '',
        customerTagDTOList: [],
        customerTagUidList: [],
        customertaggroupName: ''
      })
    },
    async toAddNew () {
      this.selectTags.splice(0, this.selectTags.length)
      this.labelLogic = 1
      this.showEdit = true
      this.isAll = false
      this.isChooseAll = false
      this.customertaggroups = await getCustomerTagGroupDtoByName({ content: '' })
      this.showEditTitle = 1
      this.selectTags.push({
        customerTagGroupUid: '',
        customerTagDTOList: [],
        customerTagUidList: [],
        customertaggroupName: ''
      })
      this.chooseConditionIndex = -1
    },
    setSelectTag (index) {
      const uid = this.selectTags[index].customerTagGroupUid
      const equalIndex = this.customertaggroups.findIndex(item => item.customertaggroupUid === uid)
      if (equalIndex !== -1) {
        const obj = Object.assign({}, this.selectTags[index])
        obj.customerTagDTOList = [{ customertagUid: '-1', choosed: false, customertagName: '全选' }, ...[...this.customertaggroups[equalIndex].customerTagDTOList]]
        obj.customertaggroupName = this.customertaggroups[equalIndex].customertaggroupName
        this.selectTags.splice(index, 1, obj)
      }
    }
  }

}

</script>
<style lang='less' scoped>
:deep(.customerData-content) {
  tr > td:first-child {
    padding-left: 20px;
  }
  .el-table__expand-icon {
    position: absolute;
    left: 5px;
    top: 50%;
    transform: translateY(-50%);
  }
  .el-table__row--level-1 {
    background: #f8f8f9;
  }
}
.customerData {
  &-showCollect {
    border: 1px solid #cfd1d5;
    box-sizing: border-box;
    border-radius: 4px;
    width: 100px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    line-height: 18px;
    text-align: center;
    cursor: pointer;

    color: #111a2e;
    i {
      font-size: 18px;
      margin-right: 2px;
    }
  }
  &-collectFooter {
    padding: 0 16px 12px;
    align-items: center;
    display: flex;
    justify-content: flex-end;
    span {
      width: 60px;
      height: 28px;
      display: flex;
      border-radius: 4px;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }
    span:first-child {
      margin-right: 8px;
      border: 1px solid #cfd1d5;
      box-sizing: border-box;
      font-size: 14px;
      color: #111a2e;
    }
    span:last-child {
      font-size: 14px;

      color: #ffffff;
      background: #2878ff;
    }
  }
  &-collectContent {
    display: flex;
    padding: 16px 12px;
    align-items: center;
    & > span:first-child {
      width: 100px;
      font-size: 14px;
      line-height: 20px;

      color: #303849;
      margin-right: 10px;
    }
  }
  &-showEditContent {
    height: calc(100vh - 120px);
    overflow: auto;
  }

  &-showCollectItemList {
    display: flex;
    flex-wrap: wrap;
    & > div {
      font-size: 14px;
      line-height: 30px;
      color: #303849;
      padding: 0 12px;
      margin-right: 8px;
      margin-bottom: 8px;
      border: 1px solid #f0f1f2;
      box-sizing: border-box;
      border-radius: 4px;
    }
  }
  &-showCollectItemHeader {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    span:first-child {
      font-size: 14px;

      color: #000000;
    }
    span:last-child {
      border: 1px solid #e2e3e5;
      border-radius: 50%;
      width: 24px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      i {
        font-size: 12px;
        cursor: pointer;
      }
    }
  }
  &-showCollectItem {
    border: 1px solid #f0f1f2;
    box-sizing: border-box;
    border-radius: 4px;
    padding: 13px;
    margin-bottom: 10px;
    &_choose {
      background: rgba(233, 241, 255, 0.3);
      border: 1px solid #2878ff;
    }
  }
  &-showCollectContent {
    padding: 14px 20px;
  }
  &-selectHandle {
    font-size: 14px;
    color: #2878ff;
    padding-left: 74px;
    cursor: pointer;
  }
  &-selectConditionsItemTitle {
    display: flex;
    align-content: center;
    margin-bottom: 10px;
    & > span {
      width: 60px;
      font-size: 14px;
      color: #000000;
      line-height: 32px;
    }
  }
  &-selectList {
    background: #ffffff;
    padding: 17px;
    padding-top: 0;
  }
  &-showEditFooter {
    height: 52px;
    z-index: 111;
    padding: 0 22px;
    display: flex;
    width: 100%;
    background: #f8f8f9;
    /* Black/Black 5% */
    position: absolute;
    bottom: 0;
    border-top: 1px solid #f3f3f4;
    align-items: center;
    span {
      width: 96px;
      height: 36px;
      border-radius: 4px;
      cursor: pointer;
      font-size: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    span:first-child {
      color: #ffffff;
      background: #2878ff;
    }
    span:last-child {
      border: 1px solid #cfd1d5;
      color: #111a2e;
      margin-left: 8px;
    }
  }
  &-selectConditionRelation {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #f8f8f9;
    padding: 0 14px;
    height: 52px;
    & > span {
      font-size: 12px;
      line-height: 14px;
      color: #b9bcc1;
    }
    & > div > span {
      font-size: 14px;
      line-height: 22px;
      color: #303849;
    }
  }
  &-showEditTitle {
    display: flex;
    font-size: 14px;
    line-height: 22px;

    color: #111a2e;
    span {
      width: 75px;
      margin-right: 30px;
      text-align: center;
      height: 43px;
      cursor: pointer;
      line-height: 44px;
    }
  }
  &-showEditTitleActive {
    border-bottom: 2px solid #2878ff;
  }
  .customerPortrait > section {
    margin-bottom: 20px;
  }
  .customerPortrait-content {
    display: flex;
    flex-wrap: wrap;
    &_choosed {
      background: #f3f3f4 !important;
    }
    span {
      padding: 8px;
      margin-right: 4px;
      font-size: 14px;
      line-height: 20px;
      color: #111a2e;
      font-weight: 600;
      border: 1px solid #e2e3e5;
      box-sizing: border-box;
      border-radius: 4px;
    }
  }
  .customerPortrait-heaader {
    display: flex;
    margin-bottom: 8px;
    align-items: center;
    span:first-child {
      margin-right: 8px;
      border: 1px solid #e0e0e0;
      width: 24px;
      height: 24px;
      border-radius: 50%;
      display: flex;
      align-items: center;

      justify-content: center;
      font-size: 12px;
      color: #404757;
    }
    span:last-child {
      font-size: 14px;
      line-height: 18px;
      color: #111a2e;
    }
  }
  &-showTagList {
    padding: 20px;
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
  }
  .el-pagination {
    margin-top: 10px;
  }
  &-contentHeader {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 10px;
    span:nth-child(2) {
      font-size: 13px;
      margin-left: 12px;
      line-height: 18px;
      color: #2878ff;
    }
    span:first-child {
      font-size: 13px;
      line-height: 18px;
      color: #646a77;
    }
  }
  &-content {
    padding: 9px 22px;
    background: white;
    border-radius: 1px;
  }
  &-tagHandle {
    width: 200px;
    display: flex;
    height: 18px;
    justify-content: flex-end;
    margin-top: 4px;
    span:last-child {
      font-size: 14px;
      line-height: 18px;
      cursor: pointer;
      line-height: 34px;
      color: #2878ff;
    }
    &_item {
      font-size: 14px;
      line-height: 34px;
      cursor: pointer;
      color: #2878ff;
    }
    &_line {
      height: 16px;
      background: #e2e3e5;
      width: 1px;
      margin: 8px 12px;
    }
  }
  &-tagGroup {
    display: flex;
    flex-direction: column;
    margin-top: 2px;
  }
  &-tagGroupItemList {
    background: #f3f3f4;
    border-radius: 4px;
    padding: 0 12px;
    font-size: 14px;
    color: #303849;
    display: flex;
    align-items: center;
    height: 28px;
    margin-right: 6px;
    margin-top: 6px;
    span {
      margin-left: 5px;
      font-size: 12px;
      cursor: pointer;
    }
  }
  &-tagGroupItemName {
    margin-right: 6px;
    font-size: 14px;
    color: #303849;
    margin-top: 6px;
  }
  &-tagGroupItem {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
  &-tagContent {
    display: flex;
    & > span {
      line-height: 32px;
      font-size: 14px;
      color: #111a2e;
      margin-right: 14px;
      margin-top: 6px;
      flex-shrink: 0;
    }
  }
  &-tagItem {
    padding: 1px 12px;
    background: #f3f3f4;
    margin-right: 6px;
    height: 32px;
    border-radius: 4px;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    span:first-child {
      font-size: 14px;
      color: #303849;
      margin-right: 8px;
    }
    span:last-child {
      color: #303849;
      font-size: 12px !important;
      cursor: pointer;
    }
  }
  &-tag {
    display: flex;
    margin-bottom: 8px;
    justify-content: space-between;
    padding: 9px 20px 15px;
    background: #ffffff;
    border-radius: 1px;
  }
  &-tag_empty {
    display: flex;
    padding: 20px;
    margin-bottom: 8px;
    align-items: center;
    background: #ffffff;
    border-radius: 1px;
    span:first-child {
      font-size: 14px;
      line-height: 18px;
      color: #111a2e;
      margin-right: 18px;
    }
    span:last-child {
      font-size: 14px;
      line-height: 18px;
      cursor: pointer;
      color: #2878ff;
    }
  }
  &-serviceNamePopover {
    display: flex;
    flex-direction: column;
    font-size: 14px;
    line-height: 28px;
    color: #303849;
  }
  &-title {
    font-size: 20px;
    line-height: 24px;
    color: #111a2e;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }
}
:deep(.customerData-selectConditionsItem) {
  padding-bottom: 15px;
  border-bottom: 1px dashed #e2e3e5;
  margin-top: 20px;
  .el-checkbox__input.is-checked + .el-checkbox__label,
  .el-checkbox__label {
    color: #303849;
  }
  .el-select .el-input,
  .el-input__inner {
    height: 32px !important;
  }
  .el-checkbox-group {
    display: flex;
    flex-wrap: wrap;
    padding-left: 60px;
    .el-checkbox {
      margin-bottom: 8px;
      font-size: 14px;
      color: #303849;
      width: 25%;
    }
  }
}
:deep(.customerData-table) {
  th {
    background: #f3f3f4;
  }
}
:deep(.customerData-showTag .el-drawer__header) {
  padding: 0 20px;
  height: 44px;
  font-size: 16px;
  line-height: 22px;
  color: #111a2e;
  margin-bottom: 0;
}
:deep(.customerData-showEdit) {
  .el-drawer__body {
    position: relative;
    overflow: auto;
  }
  .el-drawer__header {
    padding: 0 14px;
    height: 44px;
    margin-bottom: 0;
  }
}
:deep(.customerData-showTag) {
  .el-drawer__body {
    overflow-y: auto;
  }
}
</style>
